__webpack_require__.p = "/uniswap-interface/";